import { c as _c } from "react/compiler-runtime";
import { useRouter } from 'next/router';
import { parseAsInteger, parseAsString, useQueryStates } from 'nuqs';
const DEFAULT_PAGE_SIZE = 10;
export type RolesQuery = {
  rolesSearch: string;
  rolesPage: number;
  rolesPageSize: number;
};
const defaultQueryParams: RolesQuery = {
  rolesSearch: '',
  rolesPage: 0,
  rolesPageSize: DEFAULT_PAGE_SIZE
};
const useRolesQueryParams = () => {
  const $ = _c(16);
  const router = useRouter();
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      roles_search: parseAsString.withDefault(defaultQueryParams.rolesSearch),
      roles_page: parseAsInteger.withDefault(defaultQueryParams.rolesPage),
      roles_page_size: parseAsInteger.withDefault(defaultQueryParams.rolesPageSize)
    };
    t1 = {
      history: "push",
      clearOnDefault: true
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  const [queryParams, setQueryParams] = useQueryStates(t0, t1);
  let t2;
  if ($[2] !== queryParams || $[3] !== setQueryParams) {
    t2 = newQuery => {
      const updated = {
        ...queryParams,
        ...newQuery
      };
      setQueryParams({
        roles_search: updated.rolesSearch ?? defaultQueryParams.rolesSearch,
        roles_page: updated.rolesPage ?? defaultQueryParams.rolesPage,
        roles_page_size: updated.rolesPageSize ?? defaultQueryParams.rolesPageSize
      });
    };
    $[2] = queryParams;
    $[3] = setQueryParams;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const push = t2;
  let t3;
  if ($[5] !== queryParams.roles_page || $[6] !== queryParams.roles_page_size || $[7] !== queryParams.roles_search) {
    t3 = {
      page: queryParams.roles_page,
      pageSize: queryParams.roles_page_size,
      search: queryParams.roles_search
    };
    $[5] = queryParams.roles_page;
    $[6] = queryParams.roles_page_size;
    $[7] = queryParams.roles_search;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const values = t3;
  let t4;
  if ($[9] !== values) {
    t4 = {
      ...values
    };
    $[9] = values;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const requestParams = t4;
  let t5;
  if ($[11] !== push || $[12] !== requestParams || $[13] !== router.isReady || $[14] !== values) {
    t5 = {
      isReady: router.isReady,
      push,
      requestParams,
      values
    };
    $[11] = push;
    $[12] = requestParams;
    $[13] = router.isReady;
    $[14] = values;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
};
export default useRolesQueryParams;